/**
 * Datum und Uhrzeit in der Zeitzone des Orts — 20 Uhr im Kino in Berlin bleibt 20 Uhr,
 * auch wenn das Telefon gerade in Lissabon ist. Ohne Ort gilt die des Geräts.
 */
export function formatWhen(iso: string, timeZone: string | null): string {
  return new Intl.DateTimeFormat("de-DE", {
    weekday: "short",
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
    ...(timeZone ? { timeZone } : {}),
  }).format(new Date(iso));
}
